import {useEffect} from "react";
import {useAmplitude} from "~/contexts";

export const usePageView = (page: string, data?: Record<string, any>, ready: boolean = true) => {
  const {pageViewEvent} = useAmplitude();

  useEffect(() => {
    if (ready) pageViewEvent({page, data});
  }, [ready]);
};
